// src/context/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import EnglishJson from '../global/Globals_Eng.json';
import PortuJson from '../global/Globals_Portu.json';
import GlobalJson from '../global/Global_Config.json';
import AmharicJson from '../global/Globals_Amharic.json';
import KiswahiliJson from '../global/Globals_Kiswahili.json';
import { Globals } from '../global/Globals';
const LanguageContext = createContext();

const getMergedLanguageData = (lang) => {
  switch (lang) {
    case 'en':
      return { ...EnglishJson, ...GlobalJson };
    case 'pt':
      return { ...PortuJson, ...GlobalJson };
    case 'ah':
      return { ...AmharicJson, ...GlobalJson}
    case 'kw':
      return {...KiswahiliJson, ...GlobalJson}

    default:
      return Globals; // fallback
  }
};

export const LanguageProvider = ({ children }) => {
  const [languages, setLanguages] = useState(localStorage.getItem("lang") || 'en');
  const [Globals, setGlobals] = useState(getMergedLanguageData(languages));

  useEffect(() => {
    const handleStorageChange = () => {
      const lang = localStorage.getItem("lang") || 'en';
      setLanguages(lang);
      setGlobals(getMergedLanguageData(lang));
    };

    // Listen for external tab/localStorage changes
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("langChanged", handleStorageChange); // same-tab

    // Listen for same-tab changes
    // const observer = new MutationObserver(() => handleStorageChange());
    // observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("langChanged", handleStorageChange);
      //observer.disconnect();
    };
  }, []);

  return (
    <LanguageContext.Provider value={{ Globals, languages, setLanguages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
